"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var groupBy = function groupBy(collection, accessor) {
  var byValue = {};
  if (accessor != null && typeof accessor !== "function") {
    (function () {
      var key = accessor;
      accessor = function accessor(d) {
        return d[key];
      };
    })();
  }
  for (var i = 0; i < collection.length; i++) {
    var value = accessor ? accessor(collection[i]) : collection[i];
    byValue[value] = (byValue[value] || []).concat(collection[i]);
  }
  return byValue;
};

exports.default = function () {
  var A = arguments.length <= 0 || arguments[0] === undefined ? [] : arguments[0];
  var B = arguments.length <= 1 || arguments[1] === undefined ? [] : arguments[1];
  var options = arguments.length <= 2 || arguments[2] === undefined ? {} : arguments[2];


  var key = options.key != null ? options.key : "id",
      keyTo = options.keyTo != null ? options.keyTo : key,
      keyToFn = typeof keyTo === "function" ? keyTo : function (d) {
    return d[keyTo];
  },
      keyFrom = options.keyFrom != null ? options.keyFrom : key,
      keyFromFn = typeof keyFrom === "function" ? keyFrom : function (d) {
    return d[keyFrom];
  };

  var groupA = groupBy(A, keyTo),
      groupB = groupBy(B, keyFrom),
      exit = A.filter(function (a) {
    return groupB[keyToFn(a)] == null;
  }),
      enter = B.filter(function (b) {
    return groupA[keyFromFn(b)] == null;
  });

  var updating = [],
      updatedFrom = [],
      updated = B.filter(function (b) {
    return groupA[keyFromFn(b)] != null;
  });

  for (var bIndex = 0; bIndex < updated.length; bIndex++) {
    var b = updated[bIndex],
        group = groupA[keyFromFn(b)];
    for (var aIndex = 0; aIndex < group.length; aIndex++) {
      var a = group[aIndex];
      updating.push(a);
      updatedFrom.push(b);
    }
  }
  updated = updatedFrom;

  var exitTo = options.exitTo != null ? options.exitTo : Object,
      enterFrom = options.enterFrom != null ? options.enterFrom : Object,
      before = exit.concat(updating).concat(enter.map(enterFrom)),
      after = exit.map(exitTo).concat(updated).concat(enter);

  return { before: before, after: after, exit: exit, updating: updating, updated: updated, enter: enter };
};


//////////////////
// WEBPACK FOOTER
// ./~/join-transition/dist/datajoin.js
// module id = 262
// module chunks = 0